import { colors } from '@/theme/tokens';

export type RolloutStatusKey = 'active' | 'draft' | 'archived';
export type PackageTypeKey = 'apk' | 'os' | 'fw';

export interface ChipVisual {
  bg: string;
  color: string;
  label: string;
}

export const rolloutStatusConfig: Record<RolloutStatusKey, ChipVisual> = {
  active: { bg: colors.rolloutStatus.active.bg, color: colors.rolloutStatus.active.color, label: 'Active' },
  draft: { bg: colors.rolloutStatus.draft.bg, color: colors.rolloutStatus.draft.color, label: 'Draft' },
  archived: { bg: colors.rolloutStatus.archived.bg, color: colors.rolloutStatus.archived.color, label: 'Archived' },
};

export function getRolloutStatusConfig(status: RolloutStatusKey): ChipVisual {
  return rolloutStatusConfig[status] ?? rolloutStatusConfig.archived;
}

export const packageTypeConfig: Record<PackageTypeKey, ChipVisual> = {
  apk: { bg: colors.packageType.apk.bg, color: colors.packageType.apk.color, label: 'APK' },
  os: { bg: colors.packageType.os.bg, color: colors.packageType.os.color, label: 'OS' },
  fw: { bg: colors.packageType.fw.bg, color: colors.packageType.fw.color, label: 'FW' },
};

export function getPackageTypeConfig(type: PackageTypeKey): ChipVisual {
  return packageTypeConfig[type] ?? packageTypeConfig.apk;
}

export const PACKAGE_TYPE_ORDER: PackageTypeKey[] = ['apk', 'os', 'fw'];

export const DEVICE_UPDATE_EVENT_TYPES = [
  'download_progress',
  'download_success',
  'download_failed',
  'download_rejected',
  'installing',
  'install_success',
  'install_failed',
] as const;
export type DeviceUpdateEventType = (typeof DEVICE_UPDATE_EVENT_TYPES)[number];

export const DEVICE_SOFTWARE_EVENT_TYPES = [
  'download_progress',
  'download_success',
  'download_failed',
  'download_rejected',
  'installing',
  'install_success',
  'install_failed',
] as const;

const EVENT_VISUAL: Record<string, { bg: string; color: string }> = {
  download_progress: { bg: '#FFF7ED', color: '#9A3412' },
  download_success: { bg: '#EFF4FF', color: '#1D4ED8' },
  download_failed: { bg: '#FEF2F2', color: '#B42318' },
  download_rejected: { bg: '#FFF7ED', color: '#C2410C' },
  installing: { bg: '#FFF7ED', color: '#9A3412' },
  install_success: { bg: '#ECFDF5', color: '#047857' },
  install_failed: { bg: '#FEF2F2', color: '#B42318' },
};

export function getDeviceUpdateEventVisual(eventType: string): { bg: string; color: string } {
  return EVENT_VISUAL[eventType] ?? { bg: colors.grey[100], color: colors.text.secondary };
}
